const Sidebar = {
    title: 'Mi Portafolio',
    myName: 'Ryan Afrizal',
    button: [
        {
            name: 'Home',
            to: '/'
        },
        {
            name: 'Skill',
            to: '/skill'
        },
        {
            name: 'Mi Portafolio',
            to: '/project'
        }
    ]
}

export default Sidebar